import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {openFindPeopleForm} from '../../actions/navOptions';

class FindPeopleIcon extends Component {

  render() {
    const {openFindPeopleForm} = this.props;

    return (
      <div className="map-nav__btn" onClick={openFindPeopleForm}>
        <a href="#" className="btn btn-default btn-m show-map-page">
          <div className="icon-people" />
        </a>
        People
      </div>
    );
  }

}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({ openFindPeopleForm }, dispatch);
}

export default connect(undefined, mapDispatchToProps)(FindPeopleIcon);


// WEBPACK FOOTER //
// ./src/containers/NavOptions/FindPeopleIcon.js